import '../scss/app.scss';

if(typeof Site == "undefined"){
	window.Site = {};
}